import type { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { Component, Inject, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { browserBroadcastToken } from 'src/conf/di/angularProviderMapper';
import { TrackerService } from '@shared/services/tracker.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-connection-to-external-bank-ko',
  templateUrl: './connection-to-external-bank-ko.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class ConnectionToExternalBankKoComponent implements OnInit {
  constructor(
    private tracker: TrackerService,
    @Inject(browserBroadcastToken) private broadcastService: BrowserBroadcast
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'CONNECTION_EXTERNAL_BANK_KO' });
  }

  closeTab() {
    this.tracker.trackClick({
      taggingPage: 'CONNECTION_EXTERNAL_BANK_KO',
      click: frenchi18n.close_tab,
    });

    this.broadcastService.publish({ label: 'CLOSE_WEBAUTH_POPUP', data: null });
    window.close();
  }
}
